import Component from './Customers.container';

export default Component;
